export default __webpack_public_path__ + "static/formulas-67d25cb5bfbadc07b50ba6f333c472c6.png";